import { PersonalDataFieldKeys } from 'store/customer/enums'
import { ItsmePrefilledKeys } from 'store/customer/types'
import { TFunction } from 'next-i18next/pages'

/**
 * Get translation for the given keys from ItsmePrefilledKeys type
 * @param {ItsmePrefilledKeys} key
 * @returns {string}
 */
const getPrefilledKeyTranslationKey = (key: ItsmePrefilledKeys): string => {
  switch (key) {
    case PersonalDataFieldKeys.FIRSTNAME:
      return 'commonFormFields:firstName'
    case PersonalDataFieldKeys.LASTNAME:
      return 'commonFormFields:lastName'
    case PersonalDataFieldKeys.EMAIL:
      return 'commonFormFields:email.label'
    case PersonalDataFieldKeys.MOBILE_PHONE:
      return 'commonFormFields:phone.label'
  }
}

/**
 * Generate the translation string connected
 * @param {ItsmePrefilledKeys[]} keys
 * @param {TFunction} t
 * @returns {string}
 */
export const generateItsmePrefilledKeysTranslationString = (keys: ItsmePrefilledKeys[], t: TFunction): string => {
  let translationString = ''

  if (!keys || !keys.length) return translationString
  if (keys.length === 1) return t(getPrefilledKeyTranslationKey(keys[0]))

  keys.forEach((key, index) => {
    const isLastKey = index === keys.length - 1
    const isFirstKey = index === 0
    const translationKey = getPrefilledKeyTranslationKey(key)
    const translation = t(translationKey)

    if (isFirstKey) {
      translationString = translation
    } else if (isLastKey) {
      translationString += ` & ${translation.toLowerCase()}`
    } else {
      translationString += `, ${translation.toLowerCase()}`
    }
  })

  return translationString
}

/**
 * Check which fields of an object are truthy and return only these keys
 * @template Keys - default is string
 * @param {Record<Keys, unknown>} object
 * @returns {Keys[]}
 */
export const getTruthyValuesFromObject = <Keys extends string>(object?: Partial<Record<Keys, unknown>>): Keys[] => {
  return object
    ? Object.keys(object)
        .map((itsmeKey: Keys) => {
          if (object[itsmeKey]) {
            return itsmeKey
          }
        })
        .filter(Boolean)
    : []
}
